import { oxgCreateLoadingOverlay, oxgRemoveLoadingOverlay } from "../../modules/modals"
import { oxgCleanUpAbSessionItems } from "../modules/asset-briefing"
import { oxgScrollTo } from "../../modules/scroll-functions"
import { oxgCreateUf, oxgRemoveUfsFromContainer } from "../../modules/user-feedback"

const oxgSendBriefingErrorUserFeedback = ()=> {

}

window.oxgSendAssetBriefing = ()=> {
  let termsCheckbox = document.getElementById('terms-of-service-accepted')
  let privacyPolicyCheckbox = document.getElementById('privacy-policy-accepted')
  let legalDisclaimersContainer = document.getElementById('oxg-legal-disclaimers')
  let briefingTeamId = document.getElementById('briefing-team-id')
  let briefingTeamIdResponse = document.getElementById('briefing-team-id-response')
  let briefingTitle = document.getElementById('briefing-title')
  let briefingTitleResponse = document.getElementById('briefing-title-response')
  let briefingDeadline = document.getElementById('briefing-deadline')
  let briefingDeadlineResponse = document.getElementById('briefing-deadline-response')
  let tosResponse = document.getElementById('tos-response')
  let ppResponse = document.getElementById('pp-response')
  let checkFailedScrollTarget = null;
  let allowPost = true;
  console.log('briefingTeamId', briefingTeamId.classList)
  if (briefingTitle && !briefingTitle.value) {
    checkFailedScrollTarget = briefingTitle
    allowPost = false
  } else if (briefingDeadline && !briefingDeadline.value) {
    checkFailedScrollTarget = briefingDeadline
    allowPost = false
  } else if (briefingTeamId && !briefingTeamId.classList.contains('no-team') && !briefingTeamId.classList.contains('one-team') && !briefingTeamId.value) {
    checkFailedScrollTarget = briefingTeamId
    allowPost = false
  } else if (!termsCheckbox.checked || !privacyPolicyCheckbox.checked) {
    checkFailedScrollTarget = legalDisclaimersContainer
    allowPost = false
  }
  if ( !allowPost ) {

    //Error Messages Required Fields
    console.log(checkFailedScrollTarget)
    oxgScrollTo({
      element: checkFailedScrollTarget,
      offset: 100,
      callback: ()=> {

        // Briefing Title
        if(!briefingTitle.value) {
          briefingTitleResponse.classList.remove('is-hidden')
          oxgRemoveUfsFromContainer(briefingTitleResponse)
          let uf = oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Briefing must have a title',
            messageDe: 'Briefing muss einen Titel haben',
            container: briefingTitleResponse,
            classes: ['omit-m-top', 'm-s-bottom'],
            return: true,
          })
        } else {
          briefingTitleResponse.classList.add('is-hidden')
        }

        // Briefing Deadline
        if(!briefingDeadline.value) {
          briefingDeadlineResponse.classList.remove('is-hidden')
          oxgRemoveUfsFromContainer(briefingDeadlineResponse)
          let uf = oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Briefing must have a deadline',
            messageDe: 'Briefing muss eine Deadline haben',
            container: briefingDeadlineResponse,
            classes: ['omit-m-top', 'm-s-bottom'],
            return: true,
          })
        } else {
          briefingDeadlineResponse.classList.add('is-hidden')
        }

        // Briefing Team ID
        if(!briefingTeamId.value && briefingTeamIdResponse) {
          briefingTeamIdResponse.classList.remove('is-hidden')
          oxgRemoveUfsFromContainer(briefingTeamIdResponse)
          let uf = oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'Please chose a team',
            messageDe: 'Bitte wähle ein Team aus',
            container: briefingTeamIdResponse,
            classes: ['omit-m-top', 'm-s-bottom'],
            return: true,
          })
        } else if (briefingTeamIdResponse) {
          briefingTeamIdResponse.classList.add('is-hidden')
        }

        // Terms Checkbox
        if(!termsCheckbox.checked) {
          tosResponse.classList.remove('is-hidden')
          oxgRemoveUfsFromContainer(tosResponse)
          let uf = oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'You need to accept the termns of service',
            messageDe: 'Du musst die Allgemeinen Geschäftsbedingungen akzeptieren',
            container: tosResponse,
            classes: ['omit-m-top', 'm-s-bottom'],
            return: true,
          })
        } else {
          tosResponse.classList.add('is-hidden')
        }

        // Privacy Checkbox
        if(!privacyPolicyCheckbox.checked) {
          ppResponse.classList.remove('is-hidden')
          oxgRemoveUfsFromContainer(ppResponse)
          let uf = oxgCreateUf({
            format: 'box',
            icon: 'exclamation-mark--circled',
            style: 'danger',
            message: 'You need to accept the privacy policy',
            messageDe: 'Du musst die Datenschutzbestimmungen akzeptieren',
            container: ppResponse,
            classes: ['omit-m-top', 'm-s-bottom'],
            return: true,
          })
        } else {
          ppResponse.classList.add('is-hidden')
        }

      }
    })
  } else {

    // Ajax Call
    let content = {assets: oxgAssetBriefingItems, main: oxgAssetBriefingMeta}
    let button = document.getElementById('oxg-send-briefing-button')
    let addToCartButton = document.getElementById('oxg-add-briefing-to-cart-button')
    let editButton = document.getElementById('oxg-add-more-assets-button')
    if (button.getAttribute('data-in-progress') != 'true') {
      oxgCreateLoadingOverlay()
      button.setAttribute('data-in-progress', 'true')
      if (addToCartButton) { addToCartButton.setAttribute('data-in-progress', 'true') }
      editButton.setAttribute('onclick', 'event.preventDefault()')
      editButton.setAttribute('href', '')
      button.classList.add('deactivated')
      if (addToCartButton) { addToCartButton.classList.add('deactivated')}
      editButton.classList.add('deactivated')
      editButton.classList.remove('outline', 'black')
      const jq = jQuery
      jq.ajax({
          url: ajax_obj.ajax_url,
          type: 'POST',
          data: {
            action: 'oxg_send_asset_briefing',
            data: {
              content: JSON.stringify(content),
              currentSave: oxgAssetBriefingCurrentSave,
              type: 'asset-briefing'
            }
          },
          success: function(response) {
            console.log(response)
            oxgRemoveLoadingOverlay()
            button.setAttribute('data-in-progress', 'true')
            oxgCleanUpAbSessionItems();
            window.open(window.location.origin + '/response?event=' + response.data.event + '&success=' + response.success + '&id=' + response.data.oxg_id + '&message=' + response.data.message + '&pdf=' + response.data.pdf_link + '&title=' + response.data.title, '_self')
          },
          error: function(response) {
            oxgRemoveLoadingOverlay()
            console.error('An error occurred.')
            console.log('response', response)
            button.setAttribute('data-in-progress', 'true')
            oxgCleanUpAbSessionItems();
            window.open(window.location.origin + '/response?event=' + response.data.event + '&success=false&message=' + response.data.message, '_self')
          }
      });
    }
  }
}

window.myAjaxCall = ()=> {

  const jq = jQuery
  jq.ajax({
      url: ajax_obj.ajax_url,
      type: 'POST',
      data: {
        action: 'oxg_send_asset_briefing',
        data: {
          test: 'test',
        }
      },

      success: function(response) {
        console.log('success', response)
      },
      error: function() {
        console.log('failure')
      }
  });
    
}